import TradingOffersMyOperations from 'modules/trading/pages/TradingOffersMyOperations';
import { EquityMarketProvider } from '../contexts/EquityMarketContext';

const TradingOffersMyOperationsContainer = () => (
  <EquityMarketProvider>
    <TradingOffersMyOperations />
  </EquityMarketProvider>
);

export default TradingOffersMyOperationsContainer;
